<template>
  <!-- <v-list> -->
  <div v-if="wamsgs.length > 0">
    <ChatElement v-for="chat in wamsgs" :chat="chat" :key="chat._id" />
  </div>
  <div v-else>
    <v-row justify="center" class="mt-8">
      <v-icon class="mr-2">mdi-chat</v-icon> Nessun Messaggio
    </v-row>
  </div>

  <!-- </v-list> -->
</template>

<script>
import ChatElement from "../desktop/wachat_element.vue";
export default {
  components: {
    ChatElement,
  },
  computed: {
    wamsgs() {
      return this.$store.getters.get_wamsgs;
    },
  },
};
</script>
